import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { CUSTOM_SVG } from '@nms-ng2/app/shared/constants/svg';
import { EquipmentsModalsActionsService } from '@nms-ng2/app/shared/services/actions/equipments-modals-actions.service';
import { SvgHandlerService } from '@nms-ng2/app/shared/services/svg/svg-handler.service';
import { DROPDOWN_DEVICE_SERVICE, STATE } from '@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers';

import { Device } from '../../device-backup/device-backup.models';
import { DropdownShortcut } from '@nms-angular-toolkit/nms-dropdown';

/**
 * Componente responsável por exibir a lista de atalhos para GPON ONUs.
 */
@Component({
    selector: "device-actions",
    templateUrl: "./device-actions.component.html",
    styleUrls: ["./device-actions.component.scss"]
})
export class DeviceActionsComponent implements OnInit {
    @Input() selectedDevice: Device;
    @Output() onSelect: EventEmitter<void> = new EventEmitter<void>();

    public shortcuts: Array<DropdownShortcut> = [];
    public isHovered: Array<boolean> = [];
    constructor(private readonly equipmentsModalsActionsService: EquipmentsModalsActionsService,
        @Inject(DROPDOWN_DEVICE_SERVICE) private readonly dropdownDeviceService: any,
        @Inject(STATE) private readonly $state: any,
        private readonly svgHandlerService: SvgHandlerService
    ) { }

    ngOnInit(): void {
        const defaultGlobalConfig = this.equipmentsModalsActionsService.getDefaultGlobalConfig();
        const globalConfig = this.$state.params.globalConfig
            ? this.$state.params.globalConfig
            : defaultGlobalConfig;
        this.shortcuts = this.dropdownDeviceService.getShortcutToGponOnus(globalConfig, this.$state.params.device);
    }

    isVisible(shortcut) {
        return shortcut.isVisible ? shortcut.isVisible(this.selectedDevice) : true;
    }

    onShortcutClick(shortcut) {
        this.onSelect.emit();
        shortcut.action(this.selectedDevice);
    }

    getSVGImageUrl(image) {
        return this.svgHandlerService.getSVGImageUrl(image);
    }

    getCustomSvgIcon(shortcut, index) {
        const rawIcon = this.isHovered[index]
            ? this.svgHandlerService.getSvgWithCustomColor(CUSTOM_SVG[shortcut.customSvgIcon], "#fff")
            : this.svgHandlerService.getSvgWithCustomColor(CUSTOM_SVG[shortcut.customSvgIcon]);

        return this.svgHandlerService.getSVGImageUrl(rawIcon);
    }
}
